// @flow
import { relationshipReducer } from "src/utils/reducerUtils";
import patientTrendsSchema from "src/schemas/patientTrendSchema";

export const patientTrendRelationships = relationshipReducer({
  name: "patientTrends",
  relationshipSchemas: patientTrendsSchema.relationshipSchemas
});
